import { useL10n } from "@ews/react-localization-context";
import { IonContent, IonInput, IonLabel, IonSegmentButton } from "@ionic/react";
import React, { useRef, useState } from "react";
import { SwiperSlide, useSwiper } from "swiper/react";
import style from './SpecificationsOverlay.module.scss';
import { DisplayTabProps, SystemSpecificationsOverlayProps } from "./types";
import Overflow from "../../Overflow/Overflow";
import SettingsGrid from "../../Settings/SettingsGrid/SettingsGrid";
import SettingsSwiper from "../../Settings/SettingsComponents/SettingsSwiper/SettingsSwiper";
import SettingsSegment from "../../Settings/SettingsSegment/SettingsSegment";
import { useIsMobile } from "../../Responsive";
import AddressesTab from "./AddressesTab/AddressesTab";
import SystemDataTab from "./SystemDataTab/SystemDataTab";
import SubmissionDocumentsTab from "./SubmissionDocumentsTab/SubmissionDocumentsTab";
import DisplaySettingsTab from "./DisplaySettingsTab/DisplaySettingsTab";

const DisplayTab: React.FC<DisplayTabProps> = ({ name, display, children }) =>
{
    if (name === display) {
        return <>{children}</>;
    }
    return <></>;
};

const SpecificationsOverlay: React.FC<SystemSpecificationsOverlayProps> = ({ systemId, onClose }) =>
{
    type Page = {
        value: string;
        title: string;
        child: React.ReactNode;
    };
    const { translate: t } = useL10n();
    const pageList: Page[] = [
        {
            value: 'addresses',
            title: "TRVB_ADRESSES_TAB",
            child: <AddressesTab systemId={systemId} />
        },
        {
            value: 'systemData',
            title: "TRVB_SYSTEM_DATA_TAB",
            child: <SystemDataTab systemId={systemId} />
        },
        {
            value: 'submissionDocuments',
            title: t("[REACT_SYSTEM_DOCUMENTATION]"),
            child: <SubmissionDocumentsTab systemId={systemId} />
        },
        {
            value: 'displaySettings',
            title: t("[REACT_SYSTEM_DOCUMENTATION]"),
            child: <DisplaySettingsTab systemId={systemId} />
        },
    ];
    const mobileView = useIsMobile();
    const SliderComponent = mobileView ? SwiperSlide : ({ children }: { children: React.ReactNode; }) => <>{children}</>;
    const [currentSegment, setCurrentSegment] = useState<string>(pageList[0].value);
    const slideToRef = useRef<number>(0);
    const SwiperRef = useRef<any>();



    const SwiperButtonNext: React.FC<{ swipeRef: any; }> = ({ swipeRef }) =>
    {
        const swiper = useSwiper();
        return <IonInput
            label=""
            ref={swipeRef}
            onClick={() => swiper.slideTo(slideToRef.current)}
            hidden />;
    };

    return <>
        <IonContent id="documentationSettingsContent" className={style.overlaySettings} fullscreen>

            <SettingsSegment value={currentSegment} onSelect={(current: string) => setCurrentSegment(current)}>
                {pageList.map((segment, index) => (

                    <IonSegmentButton key={segment.value} value={segment.value} onClick={() =>
                    {
                        if (mobileView) {
                            slideToRef.current = index;
                            SwiperRef.current.click();
                        }
                    }}>
                        <IonLabel>{t(segment.title)}</IonLabel>
                    </IonSegmentButton>
                ))}
            </SettingsSegment>

            <Overflow minHeight={"calc(100% - 56px"} maxHeight={"calc(100% - 56px"}>
                <SettingsSwiper onSlideChange={(index) =>
                {
                    slideToRef.current = index;
                    setCurrentSegment(pageList[index].value);
                }}>
                    {mobileView && <SwiperButtonNext swipeRef={SwiperRef} />}

                    {pageList.map((page, index) =>
                    {
                        const { child, value } = page;
                        return <SliderComponent key={index}>
                            <DisplayTab name={value} display={currentSegment}>
                                <SettingsGrid>
                                    {child}
                                </SettingsGrid>
                            </DisplayTab>
                        </SliderComponent>;
                    })}

                </SettingsSwiper>
            </Overflow>
        </IonContent>
    </>;

};

export default SpecificationsOverlay;
